/**
 * @generated SignedSource<<b7d3d16aa3e4ba067ea8d87ddb1846a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StemBalanceResponse",
    "kind": "LinkedField",
    "name": "getBalanceByLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balance",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletGetBalanceByLabelQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WalletGetBalanceByLabelQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "86aa90c298f0dd62f4487dace79b77e6",
    "id": null,
    "metadata": {},
    "name": "WalletGetBalanceByLabelQuery",
    "operationKind": "query",
    "text": "query WalletGetBalanceByLabelQuery {\n  getBalanceByLabel {\n    balance\n  }\n}\n"
  }
};
})();

node.hash = "24d2a88559512ba067a01ea54f7509a3";

module.exports = node;
